import { Reducer } from 'redux'
import { OverviewPageState, OverviewPageActionTypes } from './types'

const initialState: OverviewPageState = {
    data: [],
    errors: undefined,
    loading: false   
}

const reducer: Reducer<OverviewPageState> = (state = initialState, action) => {
    switch (action.type) {
        case OverviewPageActionTypes.FETCH_REQUEST_GroupeServiceItems: {
            return { ...state, loading: true, errors: undefined}
        }
        case OverviewPageActionTypes.FETCH_SUCCESS_GroupeServiceItems: {
            return { ...state, loading: false, data: action.payload, errors: undefined}
        }
        case OverviewPageActionTypes.PUSH_REQUEST_GroupedServiceItems: {
            return { ...state, loading: false, data: action.payload, errors: undefined}
        }
        case OverviewPageActionTypes.FETCH_REQUEST_VinCheckResult: {
            return { ...state, loading: true, errors: undefined}
        }
        case OverviewPageActionTypes.FETCH_SUCCESS_VinCheckResult: {
            var serviceGroup = action.payload.ServiceGroup;
            return { ...state, loading: false, data: serviceGroup, errors: undefined}
        }
        case OverviewPageActionTypes.FETCH_FAILURE_VinCheckResult: {
            var error = action.payload;
            return { ...state, loading: false, data: null, errors: error.message}
        }
        default: {
            return state
        }
    }
}

export { reducer as mainPageReducer }
